@if (vm(); as vm) {
    @if (!vm.navigationTree?.length) {
        <ngx-skeleton-loader animation="progress-dark" [count]="8" [theme]="skeletonConfig" />
    } @else {
        @if (vm.isTabletOrLower) {
            <div class="navigation-links__mobile">
                @if (!vm.selectedCategory) {
                    @for (item of vm.navigationTree; track item.id) {
                        <lib-navigation-links-mobile-group
                            [navigationTree]="item"
                            (selectGroupId)="onSelectActiveTreeItem(item)"
                        />
                    }
                } @else {
                    <div class="mobile-group__body" [class.visible]="vm.selectedCategory">
                        <div class="mobile-group__item">
                            <a (click)="clickNavItem(vm.selectedCategory)">
                                <span>Shop all</span>
                            </a>
                        </div>

                        @for (group of vm.selectedCategory.group; track group.id) {
                            <div class="mobile-group__item">
                                <a (click)="clickNavItem(group, vm.selectedCategory)">
                                    <span>{{ group.name }}</span>
                                </a>
                            </div>
                        }
                    </div>
                }
            </div>
        }
    }

    @if (vm.isDesktopOrBigger) {
        <div class="navigation-links">
            <div class="navigation-links__inner">
                @for (item of vm.navigationTree; track item.id) {
                    <div class="navigation-links__item">
                        <p
                            class="navigation-links__item-link"
                            [class.active]="vm.activeTreeItem?.id === item.id"
                            #menuItem
                            role="button"
                            tabindex="0"
                            (click)="clickNavItem(item)"
                            (keyup.enter)="onKeyboardSelectTreeItem(item)"
                            (keyup.space)="onKeyboardSelectTreeItem(item)"
                            (mouseenter)="onMouseEnterTreeItem(item)"
                        >
                            <span class="navigation-links__item-link-title">{{ item.name }}</span>
                        </p>
                    </div>
                }
            </div>
            @if (vm.isActiveTreeItemGroup && vm.activeTreeItem) {
                <lib-navigation-links-group
                    [headerTitle]="vm.activeTreeItem.name!"
                    [navigationTree]="vm.activeTreeItem.group!"
                    [parent]="vm.activeTreeItem"
                    (backEvent)="onSelectActiveTreeItem(null)"
                    (closeEvent)="closeMenu()"
                    (focusOutsideEvent)="onFocusOutsideEvent()"
                    (shopAllEvent)="onShopAll()"
                />
            }
        </div>
    }

    @if (vm.navigationTree?.length) {
        <div class="navigation-links__body">
            <ng-content select="[body]"></ng-content>
        </div>
    }
}
